import React, {
    useEffect,
    useState,
    useRef,
    useMemo,
    useCallback,
  } from "react";
  import { Line } from "react-chartjs-2"; // 차트 라이브러리
  import DatePicker from "react-datepicker"; // 날짜 선택을 위한 라이브러리
  import "react-datepicker/dist/react-datepicker.css"; // DatePicker 스타일
  import "./JbMrtMeasurementInfo.css";
  import "../../App.css";
  import { useSelector } from "react-redux";
  import config from "../../config";
  import { CSVLink } from "react-csv"; // CSV 파일 생성을 위한 패키지 사용
  import { ko } from "date-fns/locale"; // 한국어 로케일
  import JbG2PowerSet from './JbG2PowerSet';
  import { findSeqIndex } from '../../utils/seqDataUtils';
  
  const SmartPowerMeasurementInfo = ({ SelJb }) => {
    const Jb_list = useSelector((state) => state.Jb_list || {});
    const JbMrtData = useSelector((state) => state.JbMrtData || {});
    const [index, setIndex] = useState(null);
    const dataIndex = useMemo(() => findSeqIndex(JbMrtData, SelJb), [JbMrtData, SelJb]);
  
  
    // 선택된 접속함의 인덱스를 찾아 설정
    useEffect(() => {
      if (Jb_list.seq && Array.isArray(Jb_list.seq)) {
        const foundIndex = Jb_list.seq.findIndex((seq) => SelJb === seq);
        setIndex(foundIndex !== -1 ? foundIndex : null);
      }
    }, [Jb_list, SelJb]);
  
    // 페어가 지투파워와 묶여 있는 경우: G2 전용 UI로 우회(
    // 훅 사용 없이 계산만 수행 → 훅 규칙 위반 방지)
    const g2SeqToUse = (() => {
      return null;
    })();
  
    // 활성화된 채널 정보 계산
    const activeChannels = useMemo(() => {
      const channelUseArray =
        Jb_list.jb_pv_ch_use && Jb_list.jb_pv_ch_use[index]
          ? Jb_list.jb_pv_ch_use[index].split(",")
          : [];
      const channelNameArray =
        Jb_list.jb_pv_ch_name && Jb_list.jb_pv_ch_name[index]
          ? Jb_list.jb_pv_ch_name[index].split(",")
          : [];
  
      return channelUseArray
        .map((use, i) =>
          use === "1" ? { name: channelNameArray[i], index: i } : null
        )
        .filter((channel) => channel !== null);
    }, [Jb_list, index]);
  
    const cellStyle = {
      minWidth: "150px",
      width: "150px",
      padding: "8px",
      textAlign: "center",
      verticalAlign: "middle",
      wordWrap: "break-word",
      overflowWrap: "break-word",
    };
  
    return (
      g2SeqToUse ? (
        <JbG2PowerSet SelJb={g2SeqToUse} />
      ) : (
      <div>
        <div style={{ margin: "10px", maxWidth: "1560px" }}>
          <div className="JbGenTable">
            <div className="summary-table-container">
              <table className="summary-table" style={{ marginBottom: '10px' }}>
                <tbody>
                  <tr>
                    <th style={{ backgroundColor: "#3D98DE" }}>통합전압</th>
                    <th style={{ backgroundColor: "#3D98DE" }}>통합전류</th>
                    <th style={{ backgroundColor: "#3D98DE" }}>통합전력</th>
                    <th style={{ backgroundColor: "#3D98DE" }}>
                      접속함 내부 온도
                    </th>
                  </tr>
                  <tr>
                    <td style={{ fontSize: "18px", fontWeight: "bold" }}>
                      {((JbMrtData.PvTotalVolt?.[dataIndex] ?? 0) / 10).toFixed(1)} V
                    </td>
                    <td style={{ fontSize: "18px", fontWeight: "bold" }}>
                      {((JbMrtData.pvTotalCurrent?.[dataIndex] ?? 0) / 10).toFixed(1)} A
                    </td>
                    <td style={{ fontSize: "18px", fontWeight: "bold" }}>
                      {(
                        ((JbMrtData.PvTotalVolt?.[dataIndex] ?? 0) *
                          (JbMrtData.pvTotalCurrent?.[dataIndex] ?? 0)) /
                        100000
                      ).toFixed(2)}{" "}
                      kW
                    </td>
                    <td style={{ fontSize: "18px", fontWeight: "bold" }}>
                      {((JbMrtData.temperature?.[dataIndex] ?? 0) / 10).toFixed(1)} ℃
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="Bni-table-container" style={{ marginTop: "-15px" }}>
              <table className="Bni-channel-info-table">
                <thead>
                  <tr>
                    <th style={cellStyle}>{Jb_list.jb_name[index]}</th>
                    {activeChannels.map((channel) => (
                      <th key={channel.index}>{channel.name}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>전압 (V)</td>
                    {activeChannels.map((channel, i) => (
                      <td key={`volt-${channel.index}`}>
                        {((JbMrtData.pvChVolt?.[dataIndex]?.[i] ?? 0) / 10).toFixed(1)}
                      </td>
                    ))}
                  </tr>
                  <tr>
                    <td>전류 (A)</td>
                    {activeChannels.map((channel, i) => (
                      <td key={`current-${channel.index}`}>
                        {((JbMrtData.pvChCurrent?.[dataIndex]?.[i] ?? 0) / 10).toFixed(1)}
                      </td>
                    ))}
                  </tr>
                  <tr>
                    <td>전력 (kW)</td>
                    {activeChannels.map((channel, i) => (
                      <td key={`power-${channel.index}`}>
                        {(
                          ((JbMrtData.pvChVolt?.[dataIndex]?.[i] ?? 0) *
                            (JbMrtData.pvChCurrent?.[dataIndex]?.[i] ?? 0)) /
                          100000
                        ).toFixed(2)}
                      </td>
                    ))}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <ChannelCurrentGraph
          activeChannels={activeChannels}
          seq={SelJb}
          height={"360px"}
        />
      </div>
      )
    );
  };
  
  const ChannelCurrentGraph = ({ activeChannels, seq, height }) => {
    // 시간 레이블 정의
    const timeLabels = useMemo(
      () => [
        "05:00",
        "05:10",
        "05:20",
        "05:30",
        "05:40",
        "05:50",
        "06:00",
        "06:10",
        "06:20",
        "06:30",
        "06:40",
        "06:50",
        "07:00",
        "07:10",
        "07:20",
        "07:30",
        "07:40",
        "07:50",
        "08:00",
        "08:10",
        "08:20",
        "08:30",
        "08:40",
        "08:50",
        "09:00",
        "09:10",
        "09:20",
        "09:30",
        "09:40",
        "09:50",
        "10:00",
        "10:10",
        "10:20",
        "10:30",
        "10:40",
        "10:50",
        "11:00",
        "11:10",
        "11:20",
        "11:30",
        "11:40",
        "11:50",
        "12:00",
        "12:10",
        "12:20",
        "12:30",
        "12:40",
        "12:50",
        "13:00",
        "13:10",
        "13:20",
        "13:30",
        "13:40",
        "13:50",
        "14:00",
        "14:10",
        "14:20",
        "14:30",
        "14:40",
        "14:50",
        "15:00",
        "15:10",
        "15:20",
        "15:30",
        "15:40",
        "15:50",
        "16:00",
        "16:10",
        "16:20",
        "16:30",
        "16:40",
        "16:50",
        "17:00",
        "17:10",
        "17:20",
        "17:30",
        "17:40",
        "17:50",
        "18:00",
        "18:10",
        "18:20",
        "18:30",
        "18:40",
        "18:50",
        "19:00",
        "19:10",
        "19:20",
        "19:30",
        "19:40",
        "19:50",
        "20:00",
      ],
      []
    );
  
    const [isDataAvailable, setIsDataAvailable] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [hiddenState, setHiddenState] = useState({});
    const [chartDataByTime, setChartDataByTime] = useState({});
    const chartRef = useRef(null);
    const [PvTotalVolt, setPvTotalVolt] = useState(
      Array(timeLabels.length).fill(0)
    );
    const [PvTotalCurrent, setPvTotalCurrent] = useState(
      Array(timeLabels.length).fill(0)
    );
    const [PvTemperature, setPvTemperature] = useState(
      Array(timeLabels.length).fill(0)
    );
  
    const selectedDateStr = selectedDate.toISOString().split("T")[0];
    const isWithinTimeRange = useCallback((createdAt, targetTime) => {
      const [targetHours, targetMinutes] = targetTime.split(":").map(Number);
      const dateObj = new Date(createdAt);
      const itemHours = dateObj.getUTCHours();
      const itemMinutes = dateObj.getUTCMinutes();
      const startTime = targetHours * 60 + targetMinutes;
      const endTime = startTime + 10;
      const itemTimeMinutes = itemHours * 60 + itemMinutes;
      return itemTimeMinutes >= startTime && itemTimeMinutes < endTime;
    }, []);
  
    const findClosestTimeData = useCallback(
      (filteredData, targetTime, channelIndex, seq) => {
        const closestData = filteredData.find(
          (item) =>
            isWithinTimeRange(item.created_at, targetTime) && item.seq === seq
        );
        if (!closestData) {
          return {
            value: Array(32).fill(0),
            item: null,
            PvTotalVolt: "N/A",
            PvTotalCurrent: "N/A",
            temperature: "N/A",
          };
        }
        const pvChCurrentArray = closestData.PvChCurrent
          ? closestData.PvChCurrent.split(",").map(Number)
          : Array(32).fill(0);
        return {
          value: pvChCurrentArray,
          item: closestData,
          PvTotalVolt: closestData.PvTotalVolt || "N/A",
          PvTotalCurrent: closestData.PvTotalCurrent || "N/A",
          temperature: closestData.temperature || "N/A",
        };
      },
      [isWithinTimeRange]
    );
  
    const fetchData = useCallback(
      async (date) => {
        setIsLoading(true);
        try {
          const selectedDateInKST = new Date(
            date.getTime() - date.getTimezoneOffset() * 60000
          )
            .toISOString()
            .split("T")[0];
          const response = await fetch(
            `${config.backendUrl}/get_hourly_jb_mrt_data`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                date: selectedDateInKST,
              }),
            }
          );
          const result = await response.json();
  
          if (!result.data || result.data.length === 0) {
            
            setEmptyData();
            return;
          }
  
          const filtered = result.data;
          const chartData = {};
          activeChannels.forEach((channel) => {
            chartData[channel.index] = [];
          });
  
          const newPvTotalVolt = Array(timeLabels.length).fill("N/A");
          const newPvTotalCurrent = Array(timeLabels.length).fill("N/A");
          const newPvTemperature = Array(timeLabels.length).fill("N/A");
  
          timeLabels.forEach((label, timeIndex) => {
            activeChannels.forEach((channel) => {
              const {
                value: pvChCurrentArray,
                PvTotalVolt,
                PvTotalCurrent,
                temperature,
              } = findClosestTimeData(filtered, label, channel.index, seq);
              chartData[channel.index][timeIndex] =
                pvChCurrentArray[channel.index] || null;
  
              newPvTotalVolt[timeIndex] = PvTotalVolt;
              newPvTotalCurrent[timeIndex] = PvTotalCurrent;
              newPvTemperature[timeIndex] = temperature;
            });
          });
  
          setChartDataByTime(chartData);
          setPvTotalVolt(newPvTotalVolt);
          setPvTotalCurrent(newPvTotalCurrent);
          setPvTemperature(newPvTemperature);
  
          setIsDataAvailable(true);
        } catch (error) {
          console.error("Error fetching data:", error);
          setEmptyData();
        } finally {
          setIsLoading(false);
        }
      },
      [activeChannels, findClosestTimeData, seq, timeLabels]
    );
  
    const setEmptyData = useCallback(() => {
      const emptyChartData = {};
      activeChannels.forEach((channel) => {
        emptyChartData[channel.index] = Array(timeLabels.length).fill(null);
      });
      setChartDataByTime(emptyChartData);
      setPvTotalVolt(Array(timeLabels.length).fill("N/A"));
      setPvTotalCurrent(Array(timeLabels.length).fill("N/A"));
      setPvTemperature(Array(timeLabels.length).fill("N/A"));
      setIsDataAvailable(false);
    }, [activeChannels, timeLabels]);
  
    useEffect(() => {
      if (seq) {
        fetchData(selectedDate);
      }
    }, [fetchData, selectedDate, seq]);
  
    useEffect(() => {
      const intervalId = setInterval(() => fetchData(new Date()), 660000);
      return () => clearInterval(intervalId);
    }, [fetchData]);
  
    const generateCSVData = () => {
      const csvData = [];
      timeLabels.forEach((label, index) => {
        // CSV에도 화면 표시와 동일하게 10으로 나눈 값을 저장
        const pvVolt = PvTotalVolt[index] === "N/A" || PvTotalVolt[index] === null
          ? "N/A"
          : (typeof PvTotalVolt[index] === 'number' ? PvTotalVolt[index] / 10 : parseFloat(PvTotalVolt[index]) / 10).toFixed(1);
        const pvCurrent = PvTotalCurrent[index] === "N/A" || PvTotalCurrent[index] === null
          ? "N/A"
          : (typeof PvTotalCurrent[index] === 'number' ? PvTotalCurrent[index] / 10 : parseFloat(PvTotalCurrent[index]) / 10).toFixed(1);
        const temperature = PvTemperature[index] === "N/A" || PvTemperature[index] === null
          ? "N/A"
          : (typeof PvTemperature[index] === 'number' ? PvTemperature[index] / 10 : parseFloat(PvTemperature[index]) / 10).toFixed(1);

        const row = {
          time: label,
          PvTotalVolt: pvVolt,
          PvTotalCurrent: pvCurrent,
          Temperature: temperature,
        };
        activeChannels.forEach((channel) => {
          const channelValue = chartDataByTime[channel.index]?.[index];
          row[`Channel ${channel.index} Current`] =
            channelValue === null || channelValue === undefined || channelValue === 0
              ? null
              : (channelValue / 10).toFixed(1);
        });
        csvData.push(row);
      });
      return csvData;
    };
  
    const csvHeaders = [
      { label: "Time", key: "time" },
      { label: "PvTotalVolt", key: "PvTotalVolt" },
      { label: "PvTotalCurrent", key: "PvTotalCurrent" },
      { label: "Temperature", key: "Temperature" },
      ...activeChannels.map((channel) => ({
        label: `Channel ${channel.index} Current`,
        key: `Channel ${channel.index} Current`,
      })),
    ];
  
    const chartData = {
      labels: timeLabels,
      datasets: activeChannels.map((channel, index) => ({
        label: channel.name,
        data:
          chartDataByTime[channel.index]?.map((value) =>
            value === 0 ? null : value
          ) || [],
        borderColor: [
          "#EF5350",
          "#26C6DA",
          "#FF7043",
          "#AB47BC",
          "#FFCA28",
          "#3A736A",
          "#7E57C2",
          "#60A07A",
          "#FFA726",
          "#8D6E63",
          "#66BB6A",
          "#D44A46",
          "#7F8C8D",
          "#4B4B3D",
          "#918D62",
          "#DAB672",
          "#F1D597",
          "#F4B381",
          "#F19557",
          "#E05D44",
          "#C25054",
          "#AC6D82",
          "#26A69A",
          "#6B4E3D",
        ][index % 24],
        borderWidth: 1,
        fill: false,
        tension: 0.4,
        hidden: hiddenState[channel.index] || false,
        pointRadius: chartDataByTime[channel.index]?.map((value) =>
          value === null ? 0 : 1
        ),
      })),
    };
  
    const chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        y: {
          display: true,
          title: {
            display: true,
            text: "전류 (A)",
          },
          min: 0,
          ticks: {
            callback: function (value) {
              return (value / 10).toFixed(1);
            },
          },
        },
      },
      plugins: {
        legend: {
          position: "top",
          labels: {
            boxWidth: 15,
            padding: 15,
            font: {
              size: 12,
            },
            usePointStyle: true,
          },
          onClick: (e, legendItem) => {
            const index = legendItem.datasetIndex;
            const channelIndex = activeChannels[index].index;
            setHiddenState((prevState) => ({
              ...prevState,
              [channelIndex]: !prevState[channelIndex],
            }));
          },
        },
        tooltip: {
          mode: "index",
          intersect: false,
          position: "nearest",
          yAlign: "center",
          xAlign: "right",
          caretPadding: 30,
          caretSize: 10,
          callbacks: {
            title: function (tooltipItems) {
              const dataIndex = tooltipItems[0].dataIndex;
              const timeLabel = timeLabels[dataIndex];
              const Pvvolt = PvTotalVolt[dataIndex] || "N/A";
              const Pvcurrent = PvTotalCurrent[dataIndex] || "N/A";
              const temperature = PvTemperature[dataIndex] || "N/A";
  
              return [
                `시간: ${timeLabel}`,
                `통합전압: ${(Pvvolt / 10).toFixed(1)}V`,
                `통합전류: ${(Pvcurrent / 10).toFixed(1)}A`,
                `온도: ${(temperature / 10).toFixed(1)}℃`,
              ];
            },
            label: function (tooltipItem) {
              const channelIndex = activeChannels[tooltipItem.datasetIndex]?.index;
              if (channelIndex === undefined || !chartDataByTime[channelIndex]) {
                return '';
              }
              const value = chartDataByTime[channelIndex][tooltipItem.dataIndex] || 0;
              return [`${tooltipItem.dataset.label}: ${(value / 10).toFixed(1)}A`];
            },
          },
          bodyFont: {
            size: 10,
          },
          titleFont: {
            size: 12,
          },
        },
      },
    };
  
    const handleSelectAll = () => {
      const allHiddenState = {};
      activeChannels.forEach((channel) => {
        allHiddenState[channel.index] = false;
      });
      setHiddenState(allHiddenState);
    };
  
    const handleDeselectAll = () => {
      const allHiddenState = {};
      activeChannels.forEach((channel) => {
        allHiddenState[channel.index] = true;
      });
      setHiddenState(allHiddenState);
    };
  
    return (
      <div
        style={{
          margin: "10px",
          maxWidth: "1560px",
          backgroundColor: "white",
          paddingTop: "5px",
          borderRadius: "10px",
          boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
        }}
      >
        <div
          className="control-container"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "20px",
            marginBottom: "10px",
          }}
        >
          <DatePicker
            selected={selectedDate}
            onChange={(date) => setSelectedDate(date)}
            dateFormat="yyyy-MM-dd"
            locale={ko}
            className="styled-datepicker"
            popperPlacement="bottom"
            maxDate={new Date()}
            customInput={
              <input
                style={{
                  textAlign: "center",
                  height: "25px",
                  lineHeight: "25px",
                  width: "150px",
                  marginRight: "10px",
                }}
              />
            }
          />
          <div className = "MrtJbButtonBox" style={{ display: "flex", alignItems: "center", marginLeft: "5px" }}>
            <button
              onClick={handleSelectAll}
              className="styled-button"
              style={{
                marginRight: "5px",
                height: "25px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              전체 선택
            </button>
            <button
              onClick={handleDeselectAll}
              className="styled-button"
              style={{
                height: "25px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              전체 해제
            </button>
            <CSVLink
              data={generateCSVData()}
              headers={csvHeaders}
              filename={`data_${selectedDateStr}.csv`}
              className="styled-button"
              style={{
                marginLeft: "20px",
                height: "25px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textDecoration: "none",
                backgroundColor: "#1D6C41",
              }}
            >
              CSV 다운로드
            </CSVLink>
          </div>
        </div>
        <div style={{ height: height, paddingTop: "0px" }}>
          {isLoading ? (
            <div className="loading-message">데이터를 불러오는 중...</div>
          ) : !isDataAvailable ? (
            <div className="no-data-message">데이터가 없습니다.</div>
          ) : (
            <Line ref={chartRef} data={chartData} options={chartOptions} />
          )}
        </div>
      </div>
    );
  };
  
  export default SmartPowerMeasurementInfo;
  
